<template>
    
    <v-container id="admin" class="my-10">       
        <v-row class="fill-height align-center">
            
            <v-col cols="12" md="6">                
                <h1 class="text-h5 font-weight-black orange--text mb-6 animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s text-uppercase'">Best In Class Admin Panel</h1>
                <div class="d-flex flex-column feature mb-6 pb-4 first animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon> User-friendly and clean dashboard
                    </div>
                    <div>
                        A one stop web admin to manage all aspects of your grocery business.
                    </div>
                </div>
                <div class="d-flex flex-column feature mb-6 pb-4 animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon> Order Processing
                    </div>
                    <div>
                       Best practiced order processing methodology implemented to deliver products hasslefree to your customers.
                    </div>
                </div>
                <div class="d-flex flex-column feature mb-6 pb-4 animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon> Manage Listing
                    </div>
                    <div>
                        Create product listings, add pricing, mark availability and set discount.
                    </div>
                </div>
                <div class="d-flex flex-column feature mb-6 pb-4 animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon>Manage Collection
                    </div>
                    <div>
                        Create a different collection based on user&#39;s interests or events and add related products to that collection.
                    </div>
                </div>
                <div class="d-flex flex-column feature mb-6 pb-4 animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon> Discount coupons
                    </div>
                    <div>
                        Create and manage discount coupons.
                    </div>
                </div>
                <div class="d-flex flex-column feature mb-6 pb-4 last animate" v-animate-onscroll="'animate__animated  animate__fadeInUp animate__delay-1s'">
                   <div class="text-h5 mb-2">
                    <v-icon color="orange">mdi-checkbox-multiple-marked-circle</v-icon> Push notifications
                    </div>
                    <div>
                        Send push notifications to user.
                    </div>
                </div>
            </v-col>
        
            <v-col cols="12" md="6" class="animate" v-animate-onscroll="'animate__animated  animate__fadeInRight animate__delay-1s'">
                <video style="max-width:100%;" loop muted autoplay playsinline poster="adminposter.png"><source src="https://firebasestorage.googleapis.com/v0/b/grocart-de299.appspot.com/o/ezgif.com-gif-maker%20(2).mp4?alt=media&token=fb6a78f7-da45-41c2-9931-bec049525f18"></video>
            </v-col>
            
        </v-row>
        
    </v-container>

</template>
<style type="text/css" scoped>
    .feature:not(.last){
        border-bottom: 1px solid black;
    }
</style>
<script type="text/javascript">
    export default{
        data(){
            return {
                show:false
            }
        },
        methods:{
            onIntersect(e,s){
                if(e[0].isIntersecting)
                this.show=true
                console.log(e);
                console.log(s);
            }
        }
    }
</script>